import type { PlayState, Seat } from "@ravalmatic/bridge-engine/core";

export const LOCAL_PLAYER_SEAT: Seat = 2;

export type PlayerIdentity = {
    readonly avatarId: number;
    readonly profileId: number;
};

const PLAYER_IDENTITIES: Readonly<Record<Seat, PlayerIdentity>> = {
    0: { avatarId: 1, profileId: 1 },
    1: { avatarId: 2, profileId: 2 },
    2: { avatarId: 3, profileId: 3 },
    3: { avatarId: 4, profileId: 4 }
};

export function getPlayerIdentity(seat: Seat, playerAvatarId?: number): PlayerIdentity {

    const identity = PLAYER_IDENTITIES[seat];
    return isLocalPlayerSeat(seat) && playerAvatarId !== undefined
        ? { ...identity, avatarId: playerAvatarId }
        : identity;
}

export function isLocalPlayerSeat(seat: Seat): boolean {

    return seat === LOCAL_PLAYER_SEAT;
}

export function getHandController(state: Pick<PlayState, "handToPlay" | "turn">): Seat {

    // Preserve local control of South's own cards, including when South is dummy.
    return isLocalPlayerSeat(state.handToPlay) ? LOCAL_PLAYER_SEAT : state.turn;
}
